module.exports = __webpack_public_path__ + "assets/2eb69bfadedfa8deeaf763d15e5205e6.mp3";